import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentConfig } from '../../interfaces/environment.interface';
import { AuthService } from '../auth/auth.service';
import { DecipherLocaleMarkersResponse } from '../../interfaces/decipher.interface';

@Injectable({
  providedIn: 'root',
})
export class DecipherService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.decipherUrl;

  constructor(
    private _http: HttpClient,
    private _auth: AuthService,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  getDecipherMarkers(surveyPath: string, psSurveyId: number) {
    const cmp = this._auth.user!.cmp;
    let query = '';
    if (surveyPath) {
      query += `path=${surveyPath}`;
    } else {
      query += `surveyId=${psSurveyId}`;
    }
    return this._http.get<DecipherLocaleMarkersResponse>(
      `${this._baseUrl}/v1/companies/${cmp}/surveys/markers/list?${query}`
    );
  }
}
